import { cloneDeep } from 'lodash';
import { createSelector } from 'reselect';

export const getFirstSnapshot = (history) => (history && history.length > 0) ? history[0] : null;
export const getLastSnapshot = (history) => (history && history.length > 0) ? history[history.length-1] : null;
export const get2ndToLastSnapshot
  = (history) => (history && history.length > 1) ? history[history.length-2] : null;
export const getZoneHistorySnapshotCount = (script) => !script.zoneHistory ? 0 : script.zoneHistory.length;
export const getSnapshotIndexById
  = (history, snapshotId) => history.findIndex((snapshot) => snapshot.id === snapshotId);
export const getSnapshotById = (history, snapshotId) => {
  const index = getSnapshotIndexById(history, snapshotId);
  return (index === -1) ? null : history[index];
};
export const getSnapshotsWithIdRemoved = (history, snapshotId) => {
  const newHistory = history.slice();
  newHistory.forEach((snapshot) => { if (snapshot.id === snapshotId) { delete snapshot.id; } });
  return newHistory;
};
export const getNewSnapshot = (zones, snapshotId) => ({ id: snapshotId, zones: cloneDeep(zones) });
export const isZoneHistoryInOriginalState = createSelector(
  getZoneHistorySnapshotCount,
  (zoneHistorySnapshotCount) => zoneHistorySnapshotCount <= 2
);
